export function currencyToInteger(value) {
  return value ? value.replace(/,/g, "").split(".")[0] : "0";
}
